import { render, staticRenderFns } from "./MarkdownSummary.vue?vue&type=template&id=2c7d2714&scoped=true&"
import script from "./MarkdownSummary.vue?vue&type=script&lang=js&"
export * from "./MarkdownSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7d2714",
  null
  
)

export default component.exports